import React from 'react';
import { TestCaseService } from '@/api/testCase';
import { Loading } from '@/components/Loading';
import { Section } from '@/components/Section';
import { OutlineButton } from '@/components/shared/button/OutlineButton';
import { StepDetail } from '@/components/step/StepDetail';
import { TestCaseDetail } from '@/components/testCase/TestCaseDetail';
import { useBackNavigate } from '@/utils/hooks/useBackNavigate';
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react';
import { useParams } from 'react-router-dom';

export const DetailTestCase: React.FC = () => {
  const backNavigate = useBackNavigate();
  const { testCaseId } = useParams();

  const { data, isFetching } = TestCaseService.useGet(testCaseId);

  if (isFetching) {
    return (
      <Section>
        <Loading />
      </Section>
    );
  }

  return (
    <TabGroup className="tab-group">
      <TabList className="tab-list">
        <Tab className="tab-button">Test Case</Tab>
        <Tab className="tab-button">Step</Tab>
      </TabList>

      <Section title={`${data?.case_code} - ${data?.title}`}>
        <TabPanels>
          <TabPanel>
            <TestCaseDetail testCase={data!} />
          </TabPanel>

          <TabPanel>
            <StepDetail testCase={data!} />
          </TabPanel>
        </TabPanels>
      </Section>

      <div className="p-3 mx-4 mt-0 bg-white rounded-md shadow-md">
        <OutlineButton onClick={backNavigate}>Back</OutlineButton>
      </div>
    </TabGroup>
  );
};
